export const GET_BUSINESS_UNITS = 'GET_BUSINESS_UNITS';
export const GET_BUSINESS_UNITS_SUCCESS = 'GET_BUSINESS_UNITS_SUCCESS';
export const GET_BUSINESS_UNITS_FAIL = 'GET_BUSINESS_UNITS_FAIL';

export const SHOW_DELETE_MODAL = 'SHOW_DELETE_MODAL';
export const HIDE_DELETE_MODAL = 'HIDE_DELETE_MODAL';

export const DELETE_BUSINESS_UNIT = 'DELETE_BUSINESS_UNIT';
export const DELETE_BUSINESS_UNIT_SUCCESS = 'DELETE_BUSINESS_UNIT_SUCCESS';
export const DELETE_BUSINESS_UNIT_FAIL = 'DELETE_BUSINESS_UNIT_FAIL';

export const CREATE_BUSINESS_UNIT = 'CREATE_BUSINESS_UNIT';
export const CREATE_BUSINESS_UNIT_SUCCESS = 'CREATE_BUSINESS_UNIT_SUCCESS';
export const CREATE_BUSINESS_UNIT_FAIL = 'CREATE_BUSINESS_UNIT_FAIL';

export const UPDATE_BUSINESS_UNIT = 'UPDATE_BUSINESS_UNIT';
export const UPDATE_BUSINESS_UNIT_SUCCESS = 'UPDATE_BUSINESS_UNIT_SUCCESS';
export const UPDATE_BUSINESS_UNIT_FAIL = 'UPDATE_BUSINESS_UNIT_FAIL';

export const GET_BUSINESS_UNIT = 'GET_BUSINESS_UNIT';
export const GET_BUSINESS_UNIT_SUCCESS = 'GET_BUSINESS_UNIT_SUCCESS';
export const GET_BUSINESS_UNIT_FAIL = 'GET_BUSINESS_UNIT_FAIL';